import { render, staticRenderFns } from "./BillingCheckout.vue?vue&type=template&id=6cb70f1b&scoped=true"
import script from "./BillingCheckout.vue?vue&type=script&lang=js"
export * from "./BillingCheckout.vue?vue&type=script&lang=js"
import style0 from "./BillingCheckout.vue?vue&type=style&index=0&id=6cb70f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb70f1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
